import { Link } from "react-router-dom";

const quickLinks = [
  { label: "首页", to: "/" },
  { label: "动画分类", to: "/category/all" },
  { label: "动漫资讯", to: "/news" },
  { label: "角色资料", to: "/characters" },
  { label: "关于我们", to: "/about" },
];

const hotCategories = ["冒险", "科幻", "恋爱", "校园", "热血", "奇幻", "治愈", "悬疑"];

export default function Footer() {
  return (
    <footer className="mt-20 bg-secondary-900 text-secondary-50">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center text-background-50">
                <i className="ri-flower-fill text-lg" />
              </span>
              <span className="font-heading text-xl font-extrabold">日漫</span>
            </div>
            <p className="text-sm leading-relaxed text-secondary-200">
              专注日本动画资源与行业资讯的门户平台，收录热门动画推荐、深度角色资料与最新动漫动态，为每一位动漫爱好者提供清晰的探索入口。
            </p>
            <div className="flex items-center gap-3 mt-5">
              {[
                { icon: "ri-wechat-line", label: "微信" },
                { icon: "ri-weibo-line", label: "微博" },
                { icon: "ri-bilibili-line", label: "B 站" },
                { icon: "ri-mail-line", label: "邮箱" },
              ].map((item) => (
                <button
                  key={item.icon}
                  type="button"
                  aria-label={item.label}
                  className="w-9 h-9 rounded-full bg-secondary-800 flex items-center justify-center text-secondary-100 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
                >
                  <i className={item.icon} />
                </button>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold mb-4">
              <a href="/" className="cursor-pointer hover:text-primary-300 transition-colors">
                快速导航
              </a>
            </h4>
            <ul className="space-y-2.5 text-sm text-secondary-200">
              {quickLinks.map((item) => (
                <li key={item.to}>
                  <Link to={item.to} className="cursor-pointer hover:text-primary-300 transition-colors">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold mb-4">
              <a href="/category/all" className="cursor-pointer hover:text-primary-300 transition-colors">
                热门分类
              </a>
            </h4>
            <ul className="space-y-2.5 text-sm text-secondary-200">
              {hotCategories.map((item) => (
                <li key={item}>
                  <Link
                    to={`/category/${encodeURIComponent(item)}`}
                    className="cursor-pointer hover:text-primary-300 transition-colors"
                  >
                    {item}动画
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold mb-4">
              <a href="/about" className="cursor-pointer hover:text-primary-300 transition-colors">
                联系方式
              </a>
            </h4>
            <ul className="space-y-3 text-sm text-secondary-200">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-primary-300" />
                <span>contact@riman-anime.demo</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-phone-line mt-0.5 text-primary-300" />
                <span>+86 400-000-0000</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5 text-primary-300" />
                <span>上海市浦东新区动漫创意园区 8 号楼</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line mt-0.5 text-primary-300" />
                <span>内容更新：每日 09:00 - 23:00</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-secondary-300">
          <p>© 2026 日漫 riman. 本站为演示项目，所有作品、角色与资讯均为虚构内容，不提供在线播放或下载。</p>
          <div className="flex items-center gap-4">
            <Link to="/about" className="cursor-pointer hover:text-primary-300 transition-colors">
              隐私政策
            </Link>
            <Link to="/about" className="cursor-pointer hover:text-primary-300 transition-colors">
              法律声明
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}